import { lazy } from 'react';
import ComponentLoader from 'src/components/ComponentLoader';
import Module from 'src/config/models/Module';
import ModuleBundle from 'src/config/models/ModuleBundle';

export const ItemViewModule = new Module({
  id: 'ITEM:VIEW:RESULT-TABLE',
  name: 'Item',
  label: 'Item',
  path: 'item',
  Component: ComponentLoader(
    lazy(() => import('src/content/management/Items/View'))
  ),
  actions: {
    edit: {
      id: 'ITEM:VIEW:*',
      name: 'VIEW',
      label: 'View'
    },
    delete: {
      id: 'item-delete',
      name: 'delete',
      label: 'Delete'
    },
    process: {
      id: 'ITEM-PROCESS:VIEW:*',
      name: 'Process',
      label: 'Process'
    }
  }
});

export const ItemAddModule = new Module({
  id: 'ITEM:ADD:*',
  name: 'itemAdd',
  path: 'item/add',
  Component: ComponentLoader(
    lazy(() => import('src/content/management/Items/Form'))
  ),
  actions: {
    add: {
      id: 'ITEM:ADD:*',
      name: 'Item Add',
      label: 'Add Item'
    }
  }
});

export const ItemEditModule = new Module({
  id: 'ITEM:VIEW:DETAILS',
  name: 'Item Edit',
  path: 'item/details/:itemId',
  Component: ComponentLoader(
    lazy(() => import('src/content/management/Items/Form'))
  )
});

// export const ItemProcessViewModule = new Module({
//   id: 'ITEM-PROCESS:VIEW:*',
//   name: 'Item Process View',
//   path: 'item/process',
//   pathDef: 'item/process/:id',
//   Component: ComponentLoader(
//     lazy(() => import('src/content/management/Items/ProcessView'))
//   )
// });

const ItemModules = [
  ItemViewModule,
  ItemAddModule,
  ItemEditModule,
  // ItemProcessViewModule
];

export default new ModuleBundle('Item', ItemModules);
